import { render, staticRenderFns } from "./GerarFaturaFilterBar.vue?vue&type=template&id=5b555b12"
import script from "./GerarFaturaFilterBar.vue?vue&type=script&lang=js"
export * from "./GerarFaturaFilterBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports